import React, { createContext, useContext, useState, useEffect } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

const GoogleMapsContext = createContext();

export function useGoogleMaps() {
  return useContext(GoogleMapsContext);
}

export function GoogleMapsProvider({ children }) {
  const [googleMaps, setGoogleMaps] = useState(null);

  // Cargar la API de Google Maps en el momento adecuado (una vez)
  useEffect(() => {
    const loader = new Loader({
      apiKey: 'AIzaSyA9Wi8uscGU9lC5CROYg3tselJ1sEoAyOg',
      version: 'weekly',
      
    });

    loader.load().then(() => {
      setGoogleMaps(window.google.maps); // Almacenar la instancia en el estado
    });
  }, []);

  return (
    <GoogleMapsContext.Provider value={googleMaps}>
      {children}
    </GoogleMapsContext.Provider>
  );
}
